import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/types';

type IconProps = {
  onClick?: (e: React.MouseEvent<SVGSVGElement>) => void;
  style?: FontAwesomeIconProps['style'];
  icon: IconProp;
  placement?: Placement;
  tooltip?: string;
  spin?: boolean;
  size: FontAwesomeIconProps['size'];
  className?: string;
  fixedWidth?: boolean;
  title?: string;
  color?: string;
};

export const Icon: React.FC<React.PropsWithChildren<IconProps>> = ({
  onClick = () => {},
  style,
  icon,
  placement = 'left',
  tooltip,
  spin = false,
  size,
  className,
  fixedWidth = false,
  title,
  color,
}) => {
  const t = (
    <Tooltip style={{ whiteSpace: 'pre-line' }} id="tooltip">
      {tooltip}
    </Tooltip>
  );

  return (
    <>
      {tooltip && (
        <OverlayTrigger placement={placement} overlay={t}>
          {({ ref, ...triggerHandler }) => (
            <FontAwesomeIcon
              onClick={(e) => onClick && onClick(e)}
              style={style}
              icon={icon}
              aria-hidden="true"
              spin={spin}
              size={size}
              className={className}
              widthAuto={fixedWidth}
              aria-label={title}
              color={color}
              ref={ref as any}
              {...triggerHandler}
            />
          )}
        </OverlayTrigger>
      )}

      {!tooltip && (
        <FontAwesomeIcon
          onClick={(e) => onClick && onClick(e)}
          style={style}
          icon={icon}
          aria-hidden="true"
          spin={spin}
          size={size}
          className={className}
          widthAuto={fixedWidth}
          title={title}
          color={color}
        />
      )}
    </>
  );
};
